import { useAuth } from '@/hooks/auth/useAuth'
import { Navigate, Outlet } from 'react-router'

export function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="wefa-route-status">
        <p>Authenticating...</p>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
